import styled from 'styled-components';

export const AudioContainer = styled.div`
  background-color: ${(props) => props.bgColor || '#FCEFD8'}; /* Default color if not provided */
  padding: 8px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* Apply gradient mask only when more than 3 audios and not expanded */
  height: ${(props) =>
    props.isExpanded || props.audiosLength <= 1
      ? 'auto'
      : 'calc(3 * 72px + 16px)'}; /* Adjust height based on audio block height */

  mask-image: ${(props) =>
    props.isExpanded || props.audiosLength <= 1
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
  -webkit-mask-image: ${(props) =>
    props.isExpanded || props.audiosLength <= 1
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
`;
